import React from "react";

import { AaaGameInformationUgcDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyAaaUgcProps = {
  dataInForm: AaaGameInformationUgcDataType;
};

const AaaUgcConfig: Map<string, ReadOnlyFormItem> = new Map([
  [
    "ugcDetails",
    {
      title: "describeWhatTheUgcWillBe",
    },
  ],
]);

export const ReadOnlyAaaUgc = ({ dataInForm }: ReadOnlyAaaUgcProps) => (
  <ReadOnlyForm formConfig={AaaUgcConfig} formData={dataInForm} />
);
